const icon = (name) => {
  const path = window.App.IconsPath || '/build/spritemap.svg';
  return `<svg class="icon svg-${name}" role="presentation"><use xlink:href="${path}#svg-${name}"></use></svg>`;
};

export default icon;
